import type { GameState } from '../state/gameState';
import type { GameEmitter } from '../events';
import { ARENA } from '../config/gameConfig';

// Advances each enemy toward the player. First enemy to reach the player ends
// the run. (Legacy moved enemies a fixed 0.01 units per frame — frame-rate
// dependent; here movement is per-second via dt.) Written allocation-free:
// this runs per enemy per frame.
export function updateEnemySystem(state: GameState, dt: number, emit: GameEmitter): void {
  const player = ARENA.playerPosition;
  const collisionSq = ARENA.collisionRadius * ARENA.collisionRadius;
  // Time-freeze power-up: the world holds its breath.
  const frozen = state.elapsed < state.effects.timeFreezeUntil;

  for (const enemy of state.enemies) {
    if (frozen) continue;
    const dx = player.x - enemy.position.x;
    const dy = player.y - enemy.position.y;
    const dz = player.z - enemy.position.z;
    const distSq = dx * dx + dy * dy + dz * dz;
    if (distSq > 1e-16) {
      const step = (enemy.speed * dt) / Math.sqrt(distSq);
      enemy.position.x += dx * step;
      enemy.position.y += dy * step;
      enemy.position.z += dz * step;
    }

    if (distSq < collisionSq) {
      state.status = 'gameover';
      emit.emit('gameOver', { score: state.score, reason: 'collision', enemy });
      emit.emit('statusChanged', { status: 'gameover' });
      return;
    }
  }
}
